import React from 'react';
import { styles } from './styles';
import { withStyles, StyledComponentProps, Typography } from '@material-ui/core';

import {MenuDraft as Icon} from '../../ui-components/Icons';

const comp = (props: StyledComponentProps) => {
    return (<div className={props.classes.root}>
        <Icon className={props.classes.subHeaderIcon}/>
        <Typography className={props.classes.title} variant='h6'>Bozze</Typography>
    </div>)
}

export const Drafts = withStyles(styles)(comp)